var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2581 48.3728C31.1718 50.4051 33.913 54.5634 37.5679 54.9386C42.1365 55.4075 63.6091 54.9386 65.4366 54.9386C66.8986 54.9386 68.7869 53.6879 69.5484 53.0626",
    stroke: "#EF533F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8517 71.4051C98.3794 71.4051 102.065 68.2017 102.065 64.9984C102.065 61.795 101.604 56.3036 92.8517 54.0154C84.0994 51.7273 82.2569 52.185 71.2014 44.863C60.1459 37.5411 52.7756 39.3715 43.5627 38.9139C34.3497 38.4563 25.1368 44.4053 22.373 47.1511C20.1619 49.3477 16.8452 50.2019 15.4633 50.3544C13.6207 50.3544 9.93555 51.8189 9.93555 57.6764C9.93555 63.534 13.0065 67.7441 14.542 69.117",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7164 65.667C23.273 63.7086 27.4903 60.3794 31.9056 62.7294C37.4248 65.667 37.8494 71.542 36.1511 74.4796C34.4529 77.4172 27.6601 79.9351 23.8391 76.5779C20.7823 73.8921 20.5842 69.8634 20.8672 68.1848",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9236 62.8816C74.1476 63.0455 72.2486 67.7901 71.8961 70.142L72.3964 72.618C72.9641 74.1343 75.0525 77.3563 78.8647 78.1144C83.63 79.062 88.0477 73.7611 88.0495 70.536C88.0513 67.3109 84.8935 62.6767 78.9236 62.8816Z",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3334 70C59.526 70 47.0401 70 43.5557 70",
    stroke: "#9E9C9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V112H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtB);
export default __webpack_public_path__ + "static/media/vt_b.00e4be0f7218c63a6f202572d376606e.svg";
export { ForwardRef as ReactComponent };